export const APP_VERSION_ERROR = {
  errorTitle: "The app version is not correct",
  errorMessage:
    "Please clear cache or check the appVersion property in the 'config.js' file is correct.",
};

export const API_URL_ERROR = {
  errorTitle: "API URL not found",
  errorMessage: "Please define the apiUrl property in the config.js file",
};
